module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.productgroup', {
            url: '/productgroup/{Id}?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            reloadOnSearch: false,
            data: {
                pageMetadata: {
                    title: 'Shop Product Group',
                    metaDescription: 'Shop Product Group',
                    metaRobot: 'noindex',
                },
            },
            views: {
                'left-panel@shop': {
                    template: '<wow-product-group></wow-product-group>',
                    controller: [
                        '$state', '$stateParams', 'ProductGroupService', 'FeatureService',
                        function ($state, $stateParams, productGroupService) {
                            return productGroupService.selectProductGroup($stateParams.Id).then((group) => {
                                if (!group) {
                                    $state.go('error.404', null, { location: 'replace' });
                                }
                                if (!isNaN($stateParams.Id)) {
                                    $state.transitionTo('shop.productgroup', {
                                        Id: group.Url,
                                        id: $stateParams.id,
                                        name: $stateParams.name,
                                    }, { location: 'replace' });
                                }
                                return group;
                            });
                        },
                    ],
                },
                'center-panel@shop': {
                    controller: [
                        '$state', 'ProductGroupService', function ($state, productGroupService) {
                            this.$state = $state;
                            this.productGroupService = productGroupService;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-product-group-tile-list
                            ng-if="::$ctrl.productGroupService.selectedGroup"
                            product-group-id="$ctrl.$state.params.Id"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            filter="$ctrl.$state.params.filter">
                        </wow-product-group-tile-list>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/productgroups.js